import { Routes } from '@angular/router';
import { EcommerceComponent } from './pages/dashboard/ecommerce/ecommerce.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { AppLayoutComponent } from './shared/layout/app-layout/app-layout.component';
import { BarChartComponent } from './pages/charts/bar-chart/bar-chart.component';
import { ButtonsComponent } from './pages/ui-elements/buttons/buttons.component';
import { SignInComponent } from './pages/auth-pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/auth-pages/sign-up/sign-up.component';
import { AuthGuard } from './guards/auth-guard/auth.guard';
import { DocumentTrackerComponent } from './pages/document-tracker/document-tracker.component';
import { GenAIDashboardComponent } from './pages/gen-ai-dashboard/gen-ai-dashboard.component';
import { ConnectivitysetupComponent } from './modules/connectivitysetup/connectivitysetup.component';
import { PendingUserComponent } from './pages/other-page/pending-user/pending-user.component';
import { AccessDeniedComponent } from './pages/other-page/access-denied/access-denied.component';
import { permissionGuard } from './guards/permission-guard/permission.guard';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { ExitGuard } from './guards/exit-guard/exit.guard';
import { SessionsComponent } from './pages/profile/sessions/sessions.component';

export const routes: Routes = [

  {
    path: '',
    component: AppLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        component: EcommerceComponent,
        title:
          'EDI Verse | Dashboard',
      },
      {
        path: 'profile',
        component: ProfileComponent,
        title: 'Profile Dashboard '
      },
      {
        path: 'profile/sessions',
        component: SessionsComponent,
        title: 'EDIVerse | Active Sessions'
      },
      {
        path: 'connectivitysetup',
        component: ConnectivitysetupComponent,
        title: 'Connectivity | Connectivity Setup'
      },
      // {
      //   path:'bar-chart',
      //   component:BarChartComponent,
      //   title:'Angular Bar Chart Dashboard | TailAdmin - Angular Admin Dashboard Template'
      // },
      // {
      // {
      // {
      //   path:'buttons',
      //   component:ButtonsComponent,
      //   title:'Angular Buttons Dashboard | TailAdmin - Angular Admin Dashboard Template'
      // },

      //actual
      {
        path: 'gen-ai',
        component: GenAIDashboardComponent,
        title: 'Gen AI Dashboard'
      },
      {
        path: 'document-tracker',
        component: DocumentTrackerComponent,
        title: 'Document Tracker',
        canActivate: [permissionGuard],
        data: { privileges: ['VIEW_DOCUMENT_TRACKER_MENU'] }
      },
      {
        path: 'access-denied',
        component: AccessDeniedComponent,
        title: 'Access Denied'
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        title: 'EDIVerse | Notifications'
      },
      {
        path: 'map/setup',
        loadComponent: () => import('./modules/ai-map-editor/ai-editor/ai-editor.component').then(m => m.AiEditorComponent),
        title: 'EDIVerse | Map Setup'
      },
      {
        path: 'map/map-studio/:map_id',
        loadComponent: () => import('./modules/ai-map-editor/ai-editor-chats/ai-editor-chats.component').then(m => m.AiEditorChatsComponent),
        title: 'Chats',
        canDeactivate: [ExitGuard]
      },
      {
        path: 'map/map-studio/:map_id/ai-unit-test',
        loadComponent: () => import('./modules/ai-map-editor/batch-run/batch-run.component').then(m => m.BatchRunComponent),
        title: 'AI Unit Test'
      },
      {
        path: 'ai-map-editor',
        redirectTo: 'map/setup',
        pathMatch: 'prefix'
      },
      {
        path: 'map-editor/setup/map/:map_id/ai-unit-test',
        redirectTo: 'map/map-studio/:map_id/ai-unit-test',
        pathMatch: 'full'
      },
      {
        path: 'map-editor/setup/map/:map_id',
        redirectTo: 'map/map-studio/:map_id',
        pathMatch: 'full'
      },
      {
        path: 'map-editor',
        redirectTo: 'map',
        pathMatch: 'prefix'
      },
      {
        path: 'map',
        loadChildren: () => import('./modules/map-editor/map-editor.module').then(m => m.MapEditorModule),
        title: 'EDIVerse | Map Profile'
      },
      {
        path: 'file-profile',
        loadChildren: () => import('./modules/file-profile/file-profile.module').then(m => m.FileProfileModule),
        title: 'EDIVerse | File Profile'
      },
      {
        path: 'partners',
        loadChildren: () => import('./modules/partners/partners.module').then(m => m.PartnersModule),
        title: 'EDIVerse | Partners'
      },
      {
        path: 'migrate-data/new',
        loadComponent: () => import('./modules/master-data/components/migrate-data/migrate-data.component').then(m => m.MigrateDataComponent),
        title: 'EDIVerse | Migration | New Migration',
        canActivate: [permissionGuard],
        data: { privileges: ['MIGRATION_NEW_REQUEST'], tab: 'new' }
      },
      {
        path: 'migrate-data/my-requests',
        loadComponent: () => import('./modules/master-data/components/migrate-data/migrate-data.component').then(m => m.MigrateDataComponent),
        title: 'EDIVerse | Migration | My Requests',
        canActivate: [permissionGuard],
        data: { privileges: ['MIGRATION_MY_REQUESTS'], tab: 'mine' }
      },
      {
        path: 'migrate-data/approvals',
        loadComponent: () => import('./modules/master-data/components/migrate-data/migrate-data.component').then(m => m.MigrateDataComponent),
        title: 'EDIVerse | Migration | Approvals',
        canActivate: [permissionGuard],
        data: { privileges: ['MIGRATION_APPROVALS'], tab: 'approvals' }
      },
      {
        path: 'migrate-data',
        redirectTo: 'migrate-data/new',
        pathMatch: 'full'
      },
      {
        path: 'master-data',
        loadChildren: () => import('./modules/master-data/master-data.module').then(m => m.MasterDataModule),
        title: 'EDIVerse | Master Data'
      },
      {
        path: 'developer',
        loadChildren: () => import('./modules/developer/developer.module').then(m => m.DeveloperModule),
        title: 'EDIVerse | Developer'
      },
      {
        path: 'copilot',
        loadChildren: () => import('./modules/copilot/copilot.module').then(m => m.CopilotModule),
        title: 'EDIVerse | AI Copilot'
      }
    ]
  },
  // auth pages
  {
    path: 'signin',
    component: SignInComponent,
    title: 'Sign In'
  },
  {
    path: 'signup',
    component: SignUpComponent,
    title: 'Sign Up'
  },
  // pending user page
  {
    path: 'pending-user',
    component: PendingUserComponent,
    title: 'Pending User'
  },
  // error pages
  {
    path: '**',
    component: NotFoundComponent,
    title: 'NotFound'
  },

];
